import React from 'react'
import namesImage from '@/assets/img/11.JPG'

const Name2 = () => {
  return (
    <div>
    <section class="bg-gradient-to-r from-[#000C66] via-[#000C66] to-[#000C66]">
  <div class="mx-auto max-w-screen-2xl px-4 py-16 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:h-screen lg:grid-cols-2">
      <div class="relative z-10 lg:py-16">
        <div class="relative h-64 sm:h-80 lg:h-full">
          <img
            alt=""
            src={namesImage}
            class="absolute inset-0 h-full w-full object-cover rounded-lg shadow-lg top-4"
          />
        </div>
      </div>

      <div class="relative flex items-center bg-white rounded-lg shadow-lg">
        <span
          class="hidden lg:absolute lg:inset-y-0 lg:-start-16 lg:block lg:w-16 lg:bg-white lg:shadow-lg"
        ></span>

        <div class="p-8 sm:p-16 lg:p-24">
          <h2 class="text-3xl font-bold text-black leading-tight sm:text-3xl">
          PROFESSIONAL DEVELOPMENT
          </h2>

          <p class="mt-4 text-gray-700">
          At APS, we are committed to helping our teachers excel and remain current with the latest educational practices. We offer customized training programs, workshops, and both online and in-person sessions, along with dedicated mentoring. Guided by experts, our professional development covers a range of teaching techniques and subject-specific content, ensuring that our teachers are well-equipped to enhance student learning.          </p>

          <a
            href="https://wa.me/22997221918"
            class="mt-8 inline-block rounded-full border-2 border-gray-100 bg-[#FAD02C] px-8 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-black hover:bg-blue-700 focus:outline-none focus:ring active:text-black"
          >
          TALK TO US
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
    </div>
  )
}

export default Name2
